module.exports = __webpack_public_path__ + "static/boyheartplaque-925c847f4a6fec1f798fbd96eae8db30.png";